import { ArrowRight, Construction } from "lucide-react"
import { Link } from "react-router-dom"

import { PageHeader } from "@/components/layout/page-header"
import { Button } from "@/components/ui/button"

/**
 * Заглушка для разделов меню, которых в этой консоли нет.
 *
 * Пишем прямым текстом, что раздел не реализован, и уводим в Scoring Engine.
 * Пустая страница или «данные загружаются» выглядели бы как поломка, а
 * нарисованные таблицы-пустышки — как потерянные данные.
 */
export function StubPage({ title }: { title: string }) {
  return (
    <>
      <PageHeader title={title} />
      <div className="p-5">
        <div className="mx-auto max-w-lg rounded border border-line bg-surface p-6 shadow-panel">
          <div className="flex items-center gap-2 text-fg-muted">
            <Construction className="h-4 w-4" strokeWidth={1.75} />
            <span className="stencil-label">Not implemented</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-fg">
            <span className="font-semibold">{title}</span> is part of the paydetect console layout, but
            this build implements only the Scoring Engine.
          </p>
          <p className="mt-2 text-xs leading-relaxed text-fg-muted">
            Nothing is loading here and nothing is hidden — there is no data source behind this
            section yet.
          </p>
          <Button asChild variant="primary" className="mt-5">
            <Link to="/scoring">
              Open Scoring Engine
              <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.25} />
            </Link>
          </Button>
        </div>
      </div>
    </>
  )
}

/**
 * Неизвестный адрес. Молча переадресовывать на рабочую страницу нельзя: за
 * опечаткой в ссылке и за выпиленным маршрутом внешне выглядит одинаково, и
 * тихий редирект прячет обе поломки.
 */
export function NotFoundPage() {
  return (
    <>
      <PageHeader title="Page not found" />
      <div className="p-5">
        <div className="mx-auto max-w-lg rounded border border-line bg-surface p-6 shadow-panel">
          <div className="flex items-center gap-2 text-fg-muted">
            <Construction className="h-4 w-4" strokeWidth={1.75} />
            <span className="stencil-label">Unknown address</span>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-fg">
            There is no such page in this console. Check the address or pick a section from the
            menu.
          </p>
          <Button asChild variant="primary" className="mt-5">
            <Link to="/scoring">
              Open Scoring Engine
              <ArrowRight className="h-3.5 w-3.5" strokeWidth={2.25} />
            </Link>
          </Button>
        </div>
      </div>
    </>
  )
}
